module.exports = JSON.parse('{"url":"https://s1.adlibris.com/images/58545954/bare-en-mor.jpg"}')